import React, { useState, useEffect } from "react";
import Header from "../Headers/Header";
import { useLanguage } from "../LanguageContext";
import Button from "../Button";
import axios from "axios";
import Input from "../Input";
import { useNavigate, useParams } from "react-router-dom";
import { resetPasswordTranslations } from "./resetPasswordTranslations";
import { Language } from "../../Types/types";
import { getBaseUrl } from "../Manual_List/fetch/baseEndpoint";

const Resetpassword: React.FC = () => {
  const { language } = useLanguage();
  const { token } = useParams();
  const [error, setError] = useState(false);
  const [pass, setPass] = useState("");
  const [repeatPass, setRepeatPass] = useState("");
  const [sent, setSent] = useState(false);
  const [responseLabel, setResponseLabel] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [storedToken, setStoredToken] = useState("");
  const navigate = useNavigate();

  const t = resetPasswordTranslations[language as Language];

  useEffect(() => {
    if (token) {
      setStoredToken(token);
      navigate("/resetpassword", { replace: true });
    }
  }, [token, navigate]);

  const isCorrectPass = () => {
    if (pass !== repeatPass || pass.length < 6) {
      setError(true);
      return false;
    } else {
      setError(false);
      setSent(true);
      setResponseLabel(t.passwordResetSuccess);
      setResponseMessage(t.passwordResetSuccessMessage);
      return true;
    }
  };

  const handlePass = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPass(event.target.value);
  };

  const handleRepeatPass = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRepeatPass(event.target.value);
  };

  const handleResetPass = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!isCorrectPass()) {
      return;
    }

    try {
      await axios.post(`${getBaseUrl()}/user/reset-password`, {
        token: storedToken,
        password: pass,
      });
      navigate("/login");
    } catch (error) {
      console.error("Error resetting password:", error);
      setError(true);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <Header />
      {!sent ? (
        <div className="flex flex-col items-center justify-center flex-grow">
          <form
            className="w-full sm:max-w-sm sm:bg-gray-200 sm:rounded-md sm:shadow-md sm:mb-20 sm:px-4 flex flex-col justify-between min-h-96"
            onSubmit={handleResetPass}
          >
            <div>
              <div className="flex justify-start mt-3 p-1 font-medium">
                {t.resetPassword}
              </div>
              <div className="p-1">
                <Input
                  type="password"
                  value={pass}
                  placeholder={t.password}
                  error={error}
                  onChange={handlePass}
                />
              </div>
              <div className="-mt-4 p-1">
                <Input
                  type="password"
                  value={repeatPass}
                  placeholder={t.repeatPassword}
                  error={error}
                  onChange={handleRepeatPass}
                />
              </div>
              {error && (
                <p className="text-red-500 text-sm mt-1">
                  {t.passwordsDontMatch}
                </p>
              )}
            </div>
            <div className="w-full p-1 sm:mb-2">
              <Button
                type="submit"
                className="w-full bg-green_1 text-white px-2 py-1 rounded  font-thin"
                buttonText={t.resetPasswordButton}
              />
              <Button
                className="w-full bg-gray-300 text-gray-700 px-2 py-1 rounded font-thin mt-2"
                buttonText={t.discardButton}
                onClick={() => navigate("/login")}
              />
            </div>
          </form>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center flex-grow">
          <div className="w-full sm:max-w-sm sm:bg-gray-200 sm:rounded-md sm:shadow-md sm:mb-20 sm:px-4 flex flex-col justify-between min-h-96 p-4 sm:p-6 lg:p-8">
            <div className="flex flex-col items-center mb-4 font-bold">
              {responseLabel}
            </div>
            <div className="flex items-center justify-center text-center mb-4">
              {responseMessage}
            </div>
            <Button
              className="w-full bg-black text-white px-2 py-1 rounded hover:bg-gray-800 font-medium"
              buttonText={t.loginButton}
              onClick={() => navigate("/login")}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Resetpassword;
